import { render, staticRenderFns } from "./mall_image.vue?vue&type=template&id=6f832882&scoped=true"
import script from "./mall_image.vue?vue&type=script&lang=js"
export * from "./mall_image.vue?vue&type=script&lang=js"
import style0 from "./mall_image.vue?vue&type=style&index=0&id=6f832882&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f832882",
  null
  
)

export default component.exports